import * as React from "react";
import { Device } from "../../store/apis/devicesApi";
import { Card, Fab } from "@mui/material";
import { CardContent } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import DeviceThermostatIcon from "@mui/icons-material/DeviceThermostat";

import BatteryCharging20OutlinedIcon from '@mui/icons-material/BatteryCharging20Outlined';
import BatteryCharging30OutlinedIcon from '@mui/icons-material/BatteryCharging30Outlined';
import BatteryCharging50OutlinedIcon from "@mui/icons-material/BatteryCharging50Outlined";
import BatteryCharging60OutlinedIcon from '@mui/icons-material/BatteryCharging60Outlined';
import BatteryCharging80OutlinedIcon from '@mui/icons-material/BatteryCharging80Outlined';
import BatteryCharging90OutlinedIcon from '@mui/icons-material/BatteryCharging90Outlined';
import BatteryChargingFullOutlinedIcon from '@mui/icons-material/BatteryChargingFullOutlined';

import SignalCellular0BarIcon from '@mui/icons-material/SignalCellular0Bar';
import SignalCellular1BarIcon from '@mui/icons-material/SignalCellular1Bar';
import SignalCellular2BarIcon from '@mui/icons-material/SignalCellular2Bar';
import SignalCellular3BarIcon from '@mui/icons-material/SignalCellular3Bar';
import SignalCellular4BarIcon from '@mui/icons-material/SignalCellular4Bar';

import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";

export const DeviceCard = ({
  device,
  handleEdit
}: {
  device: Device;
  handleEdit: (device: Device) => void;
}) => {
  let externalTemp: string | number = device.externalTemp
    ? device.externalTemp.temp.toFixed(1)
    : "-";
  let externalTempTime: string | number = device.externalTemp
    ? device.externalTemp.timestamp
    : "-";
  let internalTemp: string | number = device.internalTemp
    ? device.internalTemp.temp.toFixed(1)
    : "-";
  let internalTempTime = device.internalTemp
    ? device.internalTemp.timestamp
    : "-";
  let voltage: string | number = device.batteryVoltage
    ? device.batteryVoltage?.voltage.toFixed(2)
    : "-";
  let voltageTime = device.batteryVoltage
    ? device.batteryVoltage.timestamp
    : "-";
  let lteLinkTime = device.ltelink
    ? device.ltelink.timestamp
    : "-";
//  let rsrp = device.ltelink ? device.ltelink.rsrp.toString() : "-";

  let BatteryCharging = BatteryChargingFullOutlinedIcon;
  const voltageValue = device.batteryVoltage?.voltage;
  if(voltageValue && voltageValue < 4.4) BatteryCharging = BatteryCharging90OutlinedIcon;
  if(voltageValue && voltageValue < 4.25) BatteryCharging = BatteryCharging80OutlinedIcon;
  if(voltageValue && voltageValue < 4.1) BatteryCharging = BatteryCharging60OutlinedIcon;
  if(voltageValue && voltageValue < 3.95) BatteryCharging = BatteryCharging50OutlinedIcon;
  if(voltageValue && voltageValue < 3.8) BatteryCharging = BatteryCharging30OutlinedIcon;
  if(voltageValue && voltageValue < 3.65) BatteryCharging = BatteryCharging20OutlinedIcon;

  let LteLink = SignalCellular0BarIcon;
  let LteLinkText = "Ei yhteyttä";
  const rsrpValue = device.ltelink?.rsrp;
  if(rsrpValue && rsrpValue <= -120) {
    LteLink = SignalCellular1BarIcon;
    LteLinkText = "Heikko";
  };
  if(rsrpValue && rsrpValue > -120) {
    LteLink = SignalCellular2BarIcon;
    LteLinkText = "Kohtalainen";
  }
  if(rsrpValue && rsrpValue > -106) {
    LteLink = SignalCellular3BarIcon;
    LteLinkText = "Hyvä";
  }
  if(rsrpValue && rsrpValue > -91) {
    LteLink = SignalCellular4BarIcon;
    LteLinkText = "Erinomainen";
  }

  const parseTime = (timestring : string) => {
    return <>{timestring !== "-"
      ? new Date(timestring).toLocaleDateString()
      : ""}{" "}
    {timestring !== "-"
      ? new Date(timestring).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit"
      })
      : ""}</>
  }

  return (
    <Grid item xs={12} md={6}>
      <Card elevation={3}>
        <CardContent>
          <Grid container>
            <Grid item xs={11}>
              <Typography
                sx={{ fontSize: 14 }}
                color="text.secondary"
                gutterBottom
              >
                {device.deviceId.toUpperCase()}
              </Typography>
              <Typography variant="h5" component="div">
                {device.location}
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Fab
                size={"small"}
                color={"success"}
                onClick={() => handleEdit(device)}
              >
                <ModeEditOutlineOutlinedIcon />
              </Fab>
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 10 }}>
            <Grid item xs={12} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={3} md={4}>
                  <DeviceThermostatIcon
                    style={{ fontSize: "4em", color: "#005500" }}
                  />
                </Grid>
                <Grid item xs={8}>
                  <Typography sx={{ fontSize: 12 }} color="text.secondary">
                    Sensorin lämpötila
                  </Typography>
                  <Typography
                    sx={{ fontSize: 24 }}
                    style={{ color: "#005500" }}
                  >
                    {externalTemp}
                    {"\u00b0"}C
                  </Typography>
                  <Typography
                    sx={{ fontSize: 12 }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {parseTime(externalTempTime)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={3} md={4}>
                  <DeviceThermostatIcon
                    style={{ fontSize: "4em", color: "#005500" }}
                  />
                </Grid>
                <Grid item xs={8}>
                  <Typography sx={{ fontSize: 12 }} color="text.secondary">
                    Laitteen sisälämpötila
                  </Typography>
                  <Typography
                    sx={{ fontSize: 24 }}
                    style={{ color: "#005500" }}
                  >
                    {internalTemp}
                    {"\u00b0"}C
                  </Typography>
                  <Typography
                    sx={{ fontSize: 12 }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {parseTime(internalTempTime)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={3} md={4}>
                  <BatteryCharging
                    style={{ fontSize: "4em", color: "#005500" }}
                  />
                </Grid>
                <Grid item xs={8}>
                  <Typography sx={{ fontSize: 12 }} color="text.secondary">
                    Paristojen varaus
                  </Typography>
                  <Typography
                    sx={{ fontSize: 24 }}
                    style={{ color: "#005500" }}
                  >
                    {voltage}V
                  </Typography>
                  <Typography
                    sx={{ fontSize: 12 }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {parseTime(voltageTime)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={3} md={4}>
                  <LteLink
                    style={{ fontSize: "3.5em", color: "#005500" }}
                  />
                </Grid>
                <Grid item xs={8}>
                  <Typography sx={{ fontSize: 12 }} color="text.secondary">
                    Yhteyden tila
                  </Typography>
                  <Typography
                    sx={{ fontSize: 16 }}
                    style={{ color: "#005500" }}
                  >
                    {LteLinkText}
                  </Typography>
                  <Typography
                    sx={{ fontSize: 12 }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {parseTime(lteLinkTime)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 10 }}>
            <Grid item xs={12}>
              <Typography sx={{ fontSize: 12 }} color="text.secondary">
                Hälytyspuhelinnumero
              </Typography>
              <Typography sx={{ fontSize: 16 }} style={{ color: "#005500" }}>
                {device.alarmPhoneNumber}
              </Typography>
            </Grid>
            {/*<Grid item xs={12}>*/}
            {/*  <Typography sx={{ fontSize: 12 }} color="text.secondary">*/}
            {/*    Laitteen puhelinnumero*/}
            {/*  </Typography>*/}
            {/*  <Typography sx={{ fontSize: 16 }} style={{ color: "#005500" }}>*/}
            {/*    {device.phoneNumber}*/}
            {/*  </Typography>*/}
            {/*</Grid>*/}
            {/*<Grid item xs={12}>*/}
            {/*  <Typography sx={{ fontSize: 12 }} color="text.secondary">*/}
            {/*    Hälytysviesti*/}
            {/*  </Typography>*/}
            {/*  <Typography sx={{ fontSize: 16 }} style={{ color: "#005500" }}>*/}
            {/*    {device.smsTemplate}*/}
            {/*  </Typography>*/}
            {/*</Grid>*/}
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};
